var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.397,
    height: 8.934,
    viewBox: "0 0 13.397 8.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-folder-open",
    "data-name": "Icon awesome-folder-open",
    d: "M13.323,9.807,11.64,12.7a1.489,1.489,0,0,1-1.286.739H1.047a.561.561,0,0,1-.483-.84L2.248,9.706a1.489,1.489,0,0,1,1.286-.739h9.308a.561.561,0,0,1,.481.84ZM3.535,8.223h7.631V7.106A1.117,1.117,0,0,0,10.05,5.989H6.328L4.839,4.5H1.117A1.117,1.117,0,0,0,0,5.617v6.469L1.607,9.33A2.244,2.244,0,0,1,3.536,8.223Z",
    transform: "translate(0 -4.5)",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.64764ce16955f18fbe52d3152165ffd0.svg";
export { ForwardRef as ReactComponent };